import palette from "./palette";

const styles = {
  typography: {
    fontFamily: "Messina Sans",
    title: {
      fontWeight: "normal",
      fontSize: "6vw",
      lineHeight: "8vw",
    },
    pretitle: {
      fontWeight: "bold",
      fontSize: "4vw",
    },
    text: {
      fontSize: "4vw",
    },
  },
  palette: {
    primary: {
      main: palette.green,
    },
    secondary: {
      main: palette.white,
    },
    text: {
      primary: palette.dark_grey,
      secondary: palette.white
    },
    action: {
      disabledBackground: `${palette.pink}77`,
      disabled: `${palette.dark_grey}77`
    }
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          title: "h2",
          pretitle: "h5",
          subtitle: "h4",
          text: "p",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: { textAlign: "left" },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: { fontSize: "6vw" },
        input: { width: "100px" },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { background: palette.green },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: "bold",
          fontSize: "4vw",
          padding: "3vw 15vw",
          color: palette.dark_grey
        },
        contained: {
          background: palette.pink,
          '&:hover': {
            background: palette.pink
          }
        },
      },
    },
  },
  shadows: (function () {
    return Array.from(Array(25).keys()).map(() => "none");
  })(),
};

const common = { styles };

export default common;
